import Controller from '@ember/controller';

export default class AssessmentsController extends Controller {}
